import React from "react";
import EAButton from "../components/EAButton";

function NotFoundView() {
    return (
        <div className="viewContent">
            <h1>404 - Nicht gefunden</h1>
            <div>
                <p>Die angeforderte Seite konnte nicht gefunden werden.</p>
                <p>
                    <br />
                </p>
            </div>
            <EAButton id="zurueck" label="Zurück zur vorherigen Seite" onClick={() => window.history.go(-2)} />
        </div>
    );
}

export default NotFoundView;
